import MprcLoadable from "components/MprcLoadable";
import { DashboardLayout } from "layouts/DashboardLayout";
import React from "react";
import { Navigate, Route, Routes } from "react-router";

const DashboardHome = MprcLoadable(React.lazy(() => import(/* webpackChunkName: 'dashboard' */"views/dashboard")));
const AwardPanel = MprcLoadable(React.lazy(() => import(/* webpackChunkName: 'dashboard' */"views/dashboard/AwardPanel/AwardPanel")));
const ChallengePanel = MprcLoadable(React.lazy(() => import(/* webpackChunkName: 'dashboard' */"views/dashboard/ChallengePanel/ChallengePanel")));
const KnowledgePanel = MprcLoadable(React.lazy(() => import(/* webpackChunkName: 'dashboard' */"views/dashboard/KnowledegePanel/KnowledgePanel")));
const TeamPanelDashboard = MprcLoadable(React.lazy(() => import(/* webpackChunkName: 'dashboard' */"views/dashboard/TeamPanel/TeamPanelDashboard")));
const TrainingIndexDashboard = MprcLoadable(React.lazy(() => import(/* webpackChunkName: 'dashboard' */"views/dashboard/TrainingIndex")));
const TrainingPanelDashboard = MprcLoadable(React.lazy(() => import(/* webpackChunkName: 'dashboard' */"views/dashboard/TrainingPanel/TrainingPanelDashboard")));
const UserEvolutionDashboard = MprcLoadable(React.lazy(() => import(/* webpackChunkName: 'dashboard' */"views/dashboard/UserEvolution")));
const UserPanelDashboard = MprcLoadable(React.lazy(() => import(/* webpackChunkName: 'dashboard' */"views/dashboard/UserPanel")));
const BillingPanelDashboard = MprcLoadable(React.lazy(() => import(/* webpackChunkName: 'dashboard' */"views/dashboard/BillingPanel/BillingPanelDashboard")));
const ReportPanel = MprcLoadable(React.lazy(() => import(/* webpackChunkName: 'dashboard' */"views/dashboard/ReportPanel/ReportPanel")));

class Paths {
    static readonly ReportsHome = "Home";
    static readonly UserEvolution = "UserEvolution";
    static readonly TrainingPanel = "TrainingPanel";
    static readonly TrainingPanelSupervisor = "TrainingPanelSupervisor";
    static readonly TeamPanel = "TeamPanel";
    static readonly UserPanel = "UserPanel";
    static readonly ChallengePanel = "ChallengePanel";
    static readonly KnowledgePanel = "KnowledgePanel";
    static readonly AwardPanel = "AwardPanel";
    static readonly TrainingIndex = "TrainingIndex";
    static readonly BillingPanel = "BillingPanel";
    static readonly ReportPanel = "ReportPanel";
}

export class DashboardPaths {
    static readonly Prefix = "/Dashboard";

    static readonly Home = DashboardPaths.Prefix + "/" + Paths.ReportsHome;
    static readonly UserEvolution = DashboardPaths.Prefix + "/" + Paths.UserEvolution;
    static readonly TeamPanel = DashboardPaths.Prefix + "/" + Paths.TeamPanel;
    static readonly UserPanel = DashboardPaths.Prefix + "/" + Paths.UserPanel;
    static readonly TrainingPanel = DashboardPaths.Prefix + "/" + Paths.TrainingPanel;
    static readonly TrainingPanelSupervisor = DashboardPaths.Prefix + "/" + Paths.TrainingPanelSupervisor;
    static readonly ChallengePanel = DashboardPaths.Prefix + "/" + Paths.ChallengePanel;
    static readonly KnowledgePanel = DashboardPaths.Prefix + "/" + Paths.KnowledgePanel;
    static readonly AwardPanel = DashboardPaths.Prefix + "/" + Paths.AwardPanel;
    static readonly TrainingIndex = DashboardPaths.Prefix + "/" + Paths.TrainingIndex;
    static readonly BillingPanel = DashboardPaths.Prefix + "/" + Paths.BillingPanel;
    static readonly ReportPanel = DashboardPaths.Prefix + "/" + Paths.ReportPanel;
}

export const ReportsRouter = () => {
    return (
        <Routes>
            <Route element={<DashboardLayout />} >
                <Route path="" element={<Navigate to={DashboardPaths.Home} replace={true} />} />
                <Route path={Paths.ReportsHome} element={<DashboardHome />} />
                <Route path={Paths.TeamPanel} element={<TeamPanelDashboard />} />
                <Route path={Paths.TrainingPanel} element={<TrainingPanelDashboard />} />
                <Route path={Paths.ChallengePanel} element={<ChallengePanel />} />
                <Route path={Paths.KnowledgePanel} element={<KnowledgePanel />} />
                <Route path={Paths.AwardPanel} element={<AwardPanel />} />
                <Route path={Paths.TrainingIndex} element={<TrainingIndexDashboard />} />
                <Route path={Paths.UserEvolution} element={<UserEvolutionDashboard />} />
                <Route path={Paths.UserPanel} element={<UserPanelDashboard />} />
                <Route path={Paths.BillingPanel} element={<BillingPanelDashboard />} />
                <Route path={Paths.ReportPanel} element={<ReportPanel />} />
            </Route>
        </Routes>
    );
};
